import script from "./AddItem.vue?vue&type=script&setup=true&lang=js"
export * from "./AddItem.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__